module.exports = { "default": require("core-js/library/fn/get-iterator"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/get-iterator.js
// module id = ./node_modules/babel-runtime/core-js/get-iterator.js
// module chunks = 0 1 2